import { ProductRating } from '@/features/rating/types/product-rating.type';
import { GET } from '@/lib/methods';

export const getProductRating = async (productId: string) => {
  const response = await GET({
    url: `/api/rating/${productId}`,
  });
  return response as ProductRating;
};
